import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss']
})
export class ErrorPopupComponent implements OnInit {
  errors: {};

  constructor(public bsModalRef: BsModalRef) {}
 
  ngOnInit() {
    console.log(this.errors);
  }

}
